import { render } from "./DropdownUserAuthenticated.vue?vue&type=template&id=036502c2&scoped=true"
import script from "./DropdownUserAuthenticated.vue?vue&type=script&lang=ts"
export * from "./DropdownUserAuthenticated.vue?vue&type=script&lang=ts"

import "./DropdownUserAuthenticated.vue?vue&type=style&index=0&id=036502c2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-036502c2"

export default script